import React, { Component } from "react";
import { LanguageComponent } from "../components";
import { connect } from "react-redux";
import { saveLanguage, getSupportedLanguages, saveLanguageJSON } from "../actions";
import { updateRequestState, updateShowAppRequirement } from "../../../shared/actions";
import { getJSON } from "../../../utils/helper";
import { isEqual, isEmpty } from "lodash";

class Language extends Component {
   constructor(props) {
      super(props);
      this.state = {
         selectedLanguage: props.language,
      };
   }

   setLanguage = (key, value) => {
      this.props.saveLanguage(value);
      this.setState({ [key]: value });
   };

   goToScreen = (key) => {
      if (this.props.history.location && this.props.history.location.params) {
         this.props.history.push(this.props.history.location.params.to);
      } else {
         this.props.history.push(key);
      }
   };

   submit = () => {
      this.props.saveLanguage(this.state.selectedLanguage);
      this.props.updateRequestState({
         state: "language_captured",
         data: {
            language: this.props.language,
         },
         nextRoute: "instructions",
      });
      this.props.updateShowAppRequirement(true);
   };

   render() {
      return (
         <LanguageComponent
            goToScreen={this.goToScreen}
            selectedLanguage={this.state.selectedLanguage}
            supportedLanguages={this.props.supportedLanguages}
            languageJSON={this.props.languageJSON}
            submit={this.submit}
            setLanguage={this.setLanguage}
         />
      );
   }
}

const mapStateToProps = ({ language: { language, languageJSON, supportedLanguages } }) => ({
   language,
   languageJSON,
   supportedLanguages,
});

const mapDispatchToProps = {
   saveLanguage,
   saveLanguageJSON,
   getSupportedLanguages,
   updateRequestState,
   updateShowAppRequirement,
};

export default connect(mapStateToProps, mapDispatchToProps)(Language);